module.exports = __webpack_public_path__ + "img/3.6a6c2a44.png";